import type {
  FilterConfig,
  FilterDefinition,
  FilterHandler,
} from '../engine/types';
import {
  FilterId,
  FilterType,
  type MultiFilter,
  type StaticListFilter,
} from '../types/filters';
import { flightRiskDefinition, flightRiskHandler } from './flightRisk';

export const multiFlightRiskDefinition: FilterDefinition<
  MultiFilter<StaticListFilter>
> = {
  id: FilterId.MULTI_FLIGHT_RISK,
  name: 'Flight Risk',
  type: FilterType.MULTI,
  wrappedFilterId: FilterId.FLIGHT_RISK,
  instances: [],
  isVisible: true,
};

export const multiFlightRiskHandler: FilterHandler<
  MultiFilter<StaticListFilter>
> = {
  isActive(currentFilterState: MultiFilter<StaticListFilter>) {
    return currentFilterState.instances.some((instance) =>
      flightRiskHandler.isActive(instance)
    );
  },

  isDefault(
    currentFilterState: MultiFilter<StaticListFilter>,
    _definition: FilterDefinition<MultiFilter<StaticListFilter>>
  ) {
    return currentFilterState.instances.length === 0;
  },

  getEffectiveFilter(
    currentFilterState: MultiFilter<StaticListFilter>,
    _definition: FilterDefinition<MultiFilter<StaticListFilter>>,
    config: FilterConfig
  ) {
    const effectiveInstances = currentFilterState.instances.map((instance) =>
      flightRiskHandler.getEffectiveFilter(
        instance,
        flightRiskDefinition,
        config
      )
    );
    return { ...currentFilterState, instances: effectiveInstances };
  },
};
